import { useParams, Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();

  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.categorySlug === slug);

  if (!category) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-16">
        <div className="text-center">
          <h2 className="font-heading font-bold text-2xl text-foreground-900 mb-2">分类不存在</h2>
          <p className="text-foreground-600 mb-4">请检查URL是否正确</p>
          <Link to="/" className="text-primary-600 hover:text-primary-700 font-medium">返回首页</Link>
        </div>
      </div>
    );
  }

  const pageSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 911黑料网`,
    description: category.description,
    url: `https://www.911heilian.com/category/${category.slug}`,
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: categoryArticles.map((article, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        url: `https://www.911heilian.com/article/${article.id}`,
        name: article.title,
      })),
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(pageSchema)}</script>

      <main className="pt-20 pb-12">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="mb-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: category.name },
              ]}
            />
          </div>

          <div className="mb-8">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className={`${category.icon} text-lg`}></i>
              </div>
              <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
                {category.name}
              </h1>
            </div>
            <p className="text-foreground-600">{category.description}</p>
            <p className="text-sm text-foreground-500 mt-1">共 {categoryArticles.length} 篇文章</p>
          </div>

          <div className="flex gap-2 flex-wrap mb-8">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {categoryArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                <i className="ri-inbox-line text-2xl text-foreground-400"></i>
              </div>
              <h3 className="font-heading font-semibold text-lg text-foreground-800 mb-2">暂无文章</h3>
              <p className="text-foreground-500">该分类下暂时没有文章，我们会尽快更新内容。</p>
            </div>
          )}
        </div>
      </main>
    </>
  );
}